/**
 * @fileoverview SessionViewerContext - React Context Definition
 * 
 * Provides a React context for sharing viewer DOM element references across components.
 * This allows SessionViewerPortal components to access and manipulate viewer elements
 * without prop drilling.
 * 
 * @module vtc/contexts/SessionViewerContext/SessionViewerContext
 */

import { createContext } from 'react';

/**
 * Context for accessing viewer DOM element refs
 * 
 * **Context Value:**
 * ```js
 * {
 *   viewerElementsRef: React.MutableRefObject<{
 *     [sessionSid: string]: HTMLDivElement
 *   }>
 * }
 * ```
 * 
 * @type {React.Context}
 * @private
 */
export const SessionViewerContext = createContext(null);
